import { provide, inject } from "vue";
export function provideEntryFeiActionsInjections(fragments = null, refetchQueries = []) {
    provide("EntryFeiActions-fragments", fragments);
    provide("EntryFeiActions-refetchQueries", refetchQueries);
}
export function useEntryFeiActionsInjections() {
    const fragments = inject("EntryFeiActions-fragments", {});
    const refetchQueries = inject("EntryFeiActions-refetchQueries", []);
    return {
        fragments,
        refetchQueries
    };
}
export function provideEntryFeiEntryEditFragment(fragment) {
    provide("EntryFeiEntryEdit-fragment", fragment);
}
export function injectEntryFeiEntryEditFragment() {
    return inject("EntryFeiEntryEdit-fragment", "");
}
export function provideEntryFeiRegistrationQuery(query, variables) {
    provide("EntryFeiActions-RegistrationsQuery", {
        query,
        variables
    });
}
export function injectEntryFeiRegistrationQuery() {
    return inject("EntryFeiActions-RegistrationsQuery", {
        query: () => null,
        variables: () => null
    });
}
